const StepCard = ({ step, title, status, progress, totalQuestions, onClick, error, errorMessage }) => {
  const getProgressMessage = () => {
    switch (step) {
      case 2:
        return "Working for Employee";
      case 3:
        return "Employee Draft Check";
      default:
        return "";
    }
  };

  const getStepInstructions = () => {
    switch (step) {
      case 1:
        return "Complete Company Formation Checklist with all required information";
      case 2:
        return "Post Formation documents preparation after checklist confirmation";
      case 3:
        return "Tax ID (EIN) application and processing";
      default:
        return "";
    }
  };

  const handleClick = () => {
    if (onClick) { onClick(step); }
  };

  return (
    <div
      className={`usa-formation-step-card ${status}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="usa-formation-step-header">
        <h6>Step {step}</h6>
        <span className={`usa-formation-status-indicator ${status} ${error ? 'error' : ''}`}>
          {error ? 'ERROR' : status === "in-progress" ? "IN PROGRESS" : status.toUpperCase()}
        </span>
      </div>
      <h5>{title}</h5>
      {status === "in-progress" && step === 1 && (
        <div className="usa-formation-progress-container">
          <div className="usa-formation-progress-bar">
            <div
              className="usa-formation-progress-fill"
              style={{ width: `${(progress / totalQuestions) * 100}%` }}
            ></div>
          </div>
          <div className="usa-formation-progress-text">{progress}/{totalQuestions} Completed</div>
        </div>
      )}
      {status === "in-progress" && step !== 1 && (
        <div className="usa-formation-message">
          <p>{getProgressMessage()}</p>
        </div>
      )}
      {error && errorMessage && (
        <div className="usa-formation-error-message">
          <p>{errorMessage}</p>
        </div>
      )}
      <div className="usa-formation-step-hover-tooltip">
        <div className="usa-formation-tooltip-content">
          {getStepInstructions()}
        </div>
      </div>
    </div>
  );
};

export default StepCard;

